import { AdornedInput, FormField, FormHelp, Label } from '@zillow/constellation-10';

import type { ChangeEvent } from 'react';

type Props = {
  value: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onBlur?: () => void;
  error?: string;
  disabled?: boolean;
};

const ApplicationFeeFormField = ({ value, onChange, onBlur, error, disabled }: Props) => (
  <FormField
    label={<Label>Fee amount</Label>}
    required={true}
    error={Boolean(error)}
    control={
      <AdornedInput
        css={{ maxWidth: '360px' }}
        startAdornment={<AdornedInput.Adornment>$</AdornedInput.Adornment>}
        input={
          <AdornedInput.Input
            name="applicationFeeAmount"
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            type="number"
            disabled={disabled}
          />
        }
        endAdornment={<AdornedInput.Adornment>/applicant</AdornedInput.Adornment>}
      />
    }
    description={
      <FormHelp>
        {error || 'Include the cost of the background check and credit report. Enter $0 if you won’t charge a fee.'}
      </FormHelp>
    }
  />
);

export default ApplicationFeeFormField;
